import { AddressDto, ApartmentDto } from "@/api/models/coverage.model";

interface SaleProcessState {
	id: number;
	status: string;
	sale: {
		firstName: string;
		phoneNumber: string;
		addressSearch?: SaleProcessAddressSearchDto;
		address: {
			id: string;
			address: string;
			salesArea: string;
			status: string;
			lat: string;
			lng: string;
		};
		apartment: ApartmentDto;
		customer: {
			customerType: string;
			type: string;
			number: string;
			country: string;
			companyType: string;
		};
		selectedBundle: string;
	};
}

export const saleProcessInitialState = () => {
	return {
		id: -1,
		status: "",
		sale: {
			firstName: "",
			phoneNumber: "",
			address: {
				id: "-1",
				address: "",
				salesArea: "",
				status: "",
				lat: "",
				lng: ""
			} as AddressDto,
			apartment: {
				apartmentId: "-1",
				floor: "",
				door: "",
				stair: "",
				network: ""
			} as ApartmentDto,
			customer: {
				customerType: "",
				type: "",
				number: "",
				country: "",
				companyType: ""
			},
			selectedBundle: ""
		}
	};
};

const state: SaleProcessState = saleProcessInitialState();
import actions from "./actions";
import mutations from "./mutations";
import { SaleProcessAddressSearchDto } from "@/api/sale-process";

export default {
	state,
	actions,
	mutations
};
